module.exports = __webpack_public_path__ + "img/sgldds.eaacb5bf.jpg";